import { MultipleContactWarning } from 'legacy/lut/components/common/multipleContactWarning/MultipleContactWarning'
import { memo } from 'react'
import { shallowEqual } from 'react-redux'

import { IContact } from 'clickNgo/entities/contact'
import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'

import { ContactTypeSelectorSegment } from '../../configs'

import styles from './ContactTypeSelector.module.scss'

export interface ContactTypeSelectorItem {
  key: ContactTypeSelectorSegment
  text: string
}

interface IProps {
  items: ContactTypeSelectorItem[]
  selectedSegment: ContactTypeSelectorSegment
  onSegmentSelect: (segment: ContactTypeSelectorSegment) => void
  contactsBySegment: Partial<Record<ContactTypeSelectorSegment, IContact[]>>
}

export const ContactTypeSelector = memo<IProps>(
  ({ items, onSegmentSelect, selectedSegment, contactsBySegment }) => {
    return (
      <div className={styles.segmentedControl}>
        <SegmentedControl
          onItemSelect={(index) => onSegmentSelect(items[index].key)}
          selectedItem={items.findIndex((item) => item.key === selectedSegment)}
        >
          {items.map(({ key, text }) => (
            <SegmentedControl.Item key={key}>
              <span className={styles.segmentCell}>
                <Translation text={text} span />
                <MultipleContactWarning contacts={contactsBySegment[key] ?? []} />
              </span>
            </SegmentedControl.Item>
          ))}
        </SegmentedControl>
      </div>
    )
  },
  shallowEqual
)
